import { ErrorFallback, ErrorFallbackProps } from '~/components/Error';
import { EmptyErrorMessage } from '~/components/Error/Message/Empty/EmptyErrorMessage';
import { T } from '~/components/I18n';

export type HistoryFallbackProps = ErrorFallbackProps;

export const HistoryErrorFallback = ({ error, resetErrorBoundary }: HistoryFallbackProps) => {
  switch (error.message) {
    case 'EMPTY':
      return (
        <EmptyErrorMessage
          title={<T name="citizen_history_empty_title" />}
          description={<T name="citizen_history_empty" />}
          size="large"
        />
      );
    default:
      return <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />;
  }
};
